<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M8.95574 16.9307C13.3885 16.9307 16.9819 13.3489 16.9819 8.93066C16.9819 4.51239 13.3885 0.930664 8.95574 0.930664C4.83479 0.930664 1.43923 4.02624 0.981934 8.0117H8.57775L7.0652 6.32669C6.69628 5.9157 6.73038 5.28345 7.14137 4.91453C7.55236 4.5456 8.18461 4.5797 8.55353 4.99069L11.5634 8.34371C11.9045 8.72372 11.9045 9.29969 11.5634 9.6797L8.55353 13.0327C8.18461 13.4437 7.55236 13.4778 7.14137 13.1089C6.73038 12.74 6.69628 12.1077 7.0652 11.6967L8.57775 10.0117H1.00221C1.5317 13.9187 4.89083 16.9307 8.95574 16.9307Z"
    fill="currentColor"
  />
</template>
